import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import { Table, Data } from 'components/layout/Table'
import get from 'lodash/get'
import { tasksInvitedParticipants as tasksInvitedParticipantsLayout } from 'constants/layout'
import { BadgesLevels, Button, RowSelectorTd } from 'components/misc'
import { Modal } from 'containers/misc'
import MODALS from 'constants/modals'
import { ParticipantRegistrationDetailModal } from 'components/modals'
import { TaskReturn } from 'containers/forms/tasks'
import { TasksInvitedParticipantsResendModal } from 'components/modals'
import { FormattedDate } from '../../../intl'
import { setTasksInvitedParticipantsParams } from '../../../../redux/modules/api/tasks/tasks-invited-participants'

export default class TasksInvitedParticipantsTable extends PureComponent {
  static propTypes = {
    permissions: PropTypes.object.isRequired,
    tasks: PropTypes.object.isRequired,
    modal: PropTypes.func.isRequired,
    selectableInvitedParticipantsIds: PropTypes.array,
    setInvitedParticipantsSelectedTo: PropTypes.func.isRequired,
    areAllInvitedParticipantsSelected: PropTypes.bool,
    bulkSelectInvitedParticipants: PropTypes.func.isRequired,
    deleteInvitedParticipant: PropTypes.func.isRequired,
    resendInvitationEmail: PropTypes.func.isRequired,
    setTasksInvitedParticipantsParams: PropTypes.func.isRequired
  }
  static defaultProps = {
    permissions: {}
  }

  state = {
    invitedParticipantDeleteId: null,
    invitedParticipantResendId: null,
    participantRegistrationData: {}
  }

  handleClickDelete(taskId) {
    this.setState(
      {
        invitedParticipantDeleteId: taskId
      },
      () => {
        this.props.modal('delete-invited-participant')
      }
    )
  }

  handleResend(participantRegistrationId) {
    this.setState(
      {
        invitedParticipantResendId: participantRegistrationId
      },
      () => {
        this.props.modal('resend-email-to-invited-participant')
      }
    )
  }

  handleShowRegistrationDetails = participantRegistrationData => {
    this.setState(
      {
        participantRegistrationData
      },
      () => {
        this.props.modal(MODALS.PARTICIPANT_REGISTRATION_DETAIL)
      }
    )
  }

  render() {
    const {
      permissions,
      tasks,
      setTasksInvitedParticipantsParams,
      selectableInvitedParticipantsIds: selectableIds,
      areAllInvitedParticipantsSelected,
      setInvitedParticipantsSelectedTo,
      bulkSelectInvitedParticipants,
      deleteInvitedParticipant,
      resendInvitationEmail
    } = this.props

    const loading = get(tasks, 'loading')
    const list = get(tasks, 'list')
    const offset = get(tasks, 'offset')
    const limit = get(tasks, 'limit')
    const pages = get(tasks, 'pages')
    const sort = get(tasks, 'sort')
    const count = get(tasks, 'countLoaded') && get(tasks, 'count')
    const selectedIds = get(tasks, 'selectedIds') || []

    return (
      <div>
        <Table
          loading={loading}
          length={list.length}
          offset={offset}
          limit={limit}
          pages={pages}
          count={count}
          sort={sort}
          ths={tasksInvitedParticipantsLayout.tableHeaders()}
          areAllSelected={areAllInvitedParticipantsSelected ? true : undefined}
          bulkSelect={() => bulkSelectInvitedParticipants(selectedIds, selectableIds)}
          permissions={permissions}
          setParams={setTasksInvitedParticipantsParams}
        >

          <Data>
            {list.map(
              ({
                 id: taskId,
                 participantRegistration
               }) => {
                const participantRegistrationId = get(participantRegistration, 'id')

                return (
                  <tr key={taskId}>
                    <RowSelectorTd
                      enabled={selectableIds && selectableIds.some(item => item.participantRegistrationId === participantRegistrationId) ? true : undefined}
                      selected={selectedIds.some(item => item.participantRegistrationId === participantRegistrationId) ? true : undefined}
                      setSelected={val => setInvitedParticipantsSelectedTo(participantRegistrationId, taskId, val)}
                    />
                    <td>
                      <span
                        className="link"
                        onClick={() =>
                          this.handleShowRegistrationDetails(participantRegistration)}
                      >
                        {participantRegistrationId}
                      </span>
                    </td>
                    <td>{get(participantRegistration, 'firstName')}</td>
                    <td>{get(participantRegistration, 'lastName')}</td>
                    <td>{get(participantRegistration, 'createdAt') && <FormattedDate value={get(participantRegistration, 'createdAt')} />}</td>
                    <td>
                      <BadgesLevels levels={[{ awardLevel: get(participantRegistration, 'awardLevel') }]} single />
                    </td>
                    <td>{get(participantRegistration, 'email')}</td>
                    <td>{get(participantRegistration, 'organizationName')}</td>
                    <td>
                      <Button
                        onClick={() =>
                          this.handleClickDelete(taskId)
                        }
                        tiny
                        intlKey="button.delete"
                        secondary
                      >
                        Delete
                      </Button>
                    </td>
                    <td>
                      <Button
                        onClick={() => this.handleResend(participantRegistrationId)}
                        tiny
                        intlKey="button.resend"
                        primary
                      >
                        Resend
                      </Button>
                    </td>
                  </tr>
                )
              }
            )}
          </Data>
        </Table>
        <Modal id="delete-invited-participant" customActions>
          <TaskReturn
            returnTask={deleteInvitedParticipant}
            id={this.state.invitedParticipantDeleteId}
            modal={this.props.modal}
            title="Delete invited participant"
            intlKey="tasks.delete_invited_participant"
            noNote
            ctaIntlKey="button.delete"
          />
        </Modal>
        <TasksInvitedParticipantsResendModal
          modalId='resend-email-to-invited-participant'
          modal={this.props.modal}
          id={this.state.invitedParticipantResendId}
          onSubmit={resendInvitationEmail}
        />
        <ParticipantRegistrationDetailModal
          modalId={MODALS.PARTICIPANT_REGISTRATION_DETAIL}
          data={this.state.participantRegistrationData}
          modal={this.props.modal}
        />
      </div>
    )
  }
}
